import * as React from 'react'

import type { SVGProps } from 'react'

const SvgGelIconExternalLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M21.9 16.9v11.5H3.7V10.2h11.1V7.6H1V31h23.6V16.9h-2.7zM18 1v2.6h10.2l-.5-1.1L11 19l1.9 1.9L29.6 4.3l-1.2-.5V14H31V1H18z"
      stroke="none"
    />
  </svg>
)

export default SvgGelIconExternalLink
